/* eslint-disable */
import React from 'react';
import { toast } from 'react-toastify';
import qs from 'qs';
import api from '../irelandApi';
import ToastMessage from '../components/common/toast-message';
import { POST_UPLOAD_FILE_FULFILLED, POST_UPLOAD_FILE_PENDING, POST_UPLOAD_FILE_REJECTED } from '../reducers/dataImportReducer';
import fileDownload from 'react-file-download';
import { actions } from 'react-redux-form';

const prepareFormData = (payLoad) => {
  const formData = new FormData();
  
  Object.keys(payLoad).forEach((key) => {
    formData.append(`data_import[${key}]`, payLoad[key]);
  });
  
  return formData;
};

export const getDataImportIndex = () => (dispatch) => {
  dispatch({ type: 'GET_DATA_IMPORT_LIST_PENDING' });

  return api.get('/api/admin/data_imports')
    .then((response) => {
      dispatch({ type: 'GET_DATA_IMPORT_LIST_FULFILLED', payLoad: response.data });
    }).catch((error) => {
      dispatch({ type: 'GET_DATA_IMPORT_LIST_REJECTED', payLoad: error });
    });
};

export const importFiles = files => (dispatch) => {
  dispatch({ type: 'POST_IMPORT_PENDING' });

  return api.post('/api/admin/data_imports', { file_names: files })
    .then((response) => {
      dispatch({ type: 'POST_IMPORT_FULFILLED', payLoad: files });
      dispatch({ type: 'DELETE_IMPORT_FILES_FULFILLED', payLoad: files });
    }).catch((error) => {
      console.log('importFiles errors', error);
      console.log('importFiles errors', error.response.data.errors);
      error.response.data.errors.forEach((value) => {
        console.log('importFiles error value', value);
        dispatch({ type: 'ADD_TO_HISTORY', payLoad: { import_history: value[1] } });
        dispatch({ type: 'DELETE_IMPORT_FILES_FULFILLED', payLoad: [value[1].upload_name] });
        toast.error(<ToastMessage iconStyle="error" message={`${value[1].upload_name}: ${value[1].fail_reason}`} />);
      });
    });
};

export const getUploadedFile = id => (dispatch) => {
  dispatch({ type: 'GET_UPLOADED_FILE_PENDING' });

  return api.get(`/api/admin/data_imports/${id}`)
    .then((response) => {
      dispatch({ type: 'GET_UPLOADED_FILE_FULFILLED', payLoad: response.data });
      toast.success(<ToastMessage iconStyle="success" message={`${response.data.import_history.upload_name} successfully imported.`} />);
    }).catch(() => {
      dispatch({ type: 'GET_UPLOADED_FILE_REJECTED', payLoad: 'Error, cannot get upload history.' });
    });
};


export const deleteImportableFiles = files => dispatch => api.delete('/api/admin/data_imports', { params: { file_names: files } })
  .then((response) => {
    dispatch({ type: 'DELETE_IMPORT_FILES_FULFILLED', payLoad: files });
  }).catch(() => {
    dispatch({ type: 'DELETE_IMPORT_FILES_REJECTED', payLoad: 'Cannot, delete import files.' });
  });

export const uploadFile = (payload, dispatch) => {
  dispatch({ type: POST_UPLOAD_FILE_PENDING });

  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };

  return api.post('/api/admin/data_imports/upload_file', prepareFormData(payload), config)
    .then(response => {
      dispatch({ type: POST_UPLOAD_FILE_FULFILLED, payLoad: response.data });
      toast.success(<ToastMessage iconStyle="success" message={`${payload.file.name} successfully uploaded.`} />);
      dispatch(actions.reset('deep.admin_data_import.file'));
    })
    .catch(error => {
      dispatch({ type: POST_UPLOAD_FILE_REJECTED, payLoad: 'Error, can not upload file.' });
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during upload" />);
    });
};

export const downloadFile = (payload) => (dispatch) => 
  api.get(`/api/admin/data_imports/download_file?${qs.stringify({ data_import: { file_name: payload } }, { encodeValuesOnly: true } )}`)
    .then(response => {
      fileDownload(response.data, payload);
    })
    .catch(error => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during download" />);
    });



// WEBPACK FOOTER //
// ./src/actions/data-import.js